export default __webpack_public_path__ + "static/media/mkcay.5b13e404.jpg";